module.exports = __webpack_public_path__ + "static/img/Elekana-Suavi.75e48eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Elekana-Suavi.jpg
// module id = hl2R
// module chunks = 0